import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Form
} from 'reactstrap';

export default function InvoiceEditModal({ isOpen, toggle }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Invoice Details</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="businessName">Business name</Label>
            <Input id="businessName" defaultValue="Night And Day" />
          </FormGroup>
          <FormGroup>
            <Label for="poNumber">PO Number</Label>
            <Input id="poNumber" defaultValue="Saif Riaz" />
          </FormGroup>
          <FormGroup>
            <Label for="address">Business address</Label>
            <Input id="address" />
          </FormGroup>
          <FormGroup>
            <Label for="city">City</Label>
            <Input id="city" />
          </FormGroup>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="state">State</Label>
                <Input id="state" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="zip">Zip Code</Label>
                <Input id="zip" />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label for="country">Country</Label>
            <Input type="select" id="country">
              <option value="usa">United States</option>
              <option value="uk">United Kingdom</option>
              <option value="canada">Canada</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="subscribers">Subscribers</Label>
            <Input id="subscribers" defaultValue="nightanddaydentistleeds@gmail.com" />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={toggle}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
